import React from 'react';
import { BoxSkeleton, SkeletonLoader } from '@europrocurement/flexy-components';
import { Box } from '@mui/material';
import DossierDocumentsSign from '../DossierDocumentsSign/DossierDocumentsSign';
import { useDossierDocumentSignContext } from '../../../providers/DossierDocumentSignContext';

const DocumentSignTab: React.FunctionComponent = function () {
    const { loading } = useDossierDocumentSignContext();

    return (
        <Box data-testid="document-sign-tab">
            <SkeletonLoader
                isLoading={loading}
                containerSx={{
                    marginTop: '10px',
                    marginBottom: '10px',
                }}
                skeleton={
                    <BoxSkeleton
                        sx={{
                            height: '250px',
                        }}
                    />
                }
            >
                <DossierDocumentsSign />
            </SkeletonLoader>
        </Box>
    );
};

export default DocumentSignTab;
